export default __webpack_public_path__ + "static/media/bg_1950.7e3a55e9.png";